import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import ErrorLayout from '@/views/_layouts/ErrorLayout';

function NotFound() {
  return (
    <ErrorLayout>
      <Helmet title="页面无法访问" />
      <img src="/resources/images/error/404.svg" alt="404" />
      <h2>404 | 页面无法访问</h2>
      <div className="nav-help">
        <Link to="/" className="text-[#033C6D]">
          返回首页
        </Link>
      </div>
    </ErrorLayout>
  );
}

export default NotFound;

export function ThrowNotFound(): React.ReactElement {
  throw new Error('No matching route.');
  return null;
}
